import {
    ACCOUNT,
    ACCOUNT_NS,
    CATEGORIES_NS,
    CONFIGURATION,
    EMPLOYEES,
    EMPLOYEES_NS,
    MENU_NS,
    PRODUCTS,
    PRODUCTS_NS,
    PRODUCT_CATEGORIES,
    STORE_CLOSING,
    STORE_CLOSING_NS,
    STORE_CONFIG_NS,
    TABLES,
    TABLES_NS,
    USER_NS
} from '../Constants';
import { ImageType } from '../types';

const GR_TRANSLATION = {
    required_field: 'Υποχρεωτικό πεδίο',
    save: 'ΑΠΟΘΗΚΕΥΣΗ',
    delete: 'ΔΙΑΓΡΑΦΗ',
    cancel: 'ΑΚΥΡΟ',
    username: 'USERNAME',
    password: 'ΚΩΔΙΚΟΣ',
    error: 'Σφάλμα',
    [`${ACCOUNT_NS}.password_mismatch`]: 'Οι κωδικοί δεν ταιριάζουν',
    [`${ACCOUNT_NS}.repeat_password`]: 'ΕΠΙΒΕΒΑΙΩΣΗ ΚΩΔΙΚΟΥ',
    [`${ACCOUNT_NS}.successful_update`]: 'Ο κωδικός αποθηκεύτηκε με επιτυχία!',
    [`${CATEGORIES_NS}.name`]: 'ΟΝΟΜΑΣΙΑ',
    [`${CATEGORIES_NS}.icon`]: 'ΕΙΚΟΝΙΔΙΟ',
    [`${EMPLOYEES_NS}.name`]: 'ΟΝΟΜΑ',
    [`${EMPLOYEES_NS}.phone`]: 'ΤΗΛΕΦΩΝΟ',
    [`${USER_NS}.logged_user`]: 'ΣΥΝΔΕΔΕΜΕΝΟΣ ΧΡΗΣΤΗΣ',
    [`${MENU_NS}.product_categories`]: 'Κατηγορίες προϊόντων',
    [`${MENU_NS}.products`]: 'Προϊόντα',
    [`${MENU_NS}.tables`]: 'Τραπέζια',
    [`${MENU_NS}.employees`]: 'Υπάλληλοι',
    [`${MENU_NS}.store_configuration`]: 'Ρυθμίσεις καταστήματος',
    [`${MENU_NS}.account_configuration`]: 'Ρυθμίσεις λογαριασμού',
    [`${MENU_NS}.store_closing`]: 'Κλείσιμο καταστήματος',
    [`${PRODUCTS_NS}.price_validation`]:
        'Η τιμή πρέπει να είναι κενή όταν υπάρχει προεπιλογή',
    [`${PRODUCTS_NS}.variety_validation`]: 'Επιτρέπεται μόνο μία προεπιλογή',
    [`${PRODUCTS_NS}.name`]: 'ΟΝΟΜΑ',
    [`${PRODUCTS_NS}.description`]: 'ΠΕΡΙΓΡΑΦΗ',
    [`${PRODUCTS_NS}.category`]: 'ΚΑΤΗΓΟΡΙΑ',
    [`${PRODUCTS_NS}.price`]: 'ΤΙΜΗ',
    [`${PRODUCTS_NS}.varieties`]: 'ΕΠΙΛΟΓΕΣ',
    [`${PRODUCTS_NS}.add_variety`]: 'Προσθήκη νέας επιλογής',
    [`${PRODUCTS_NS}.remove_variety`]: 'Αφαίρεση επιλογής',
    [`${PRODUCTS_NS}.default_variety`]: 'ΠΡΟΕΠΙΛΟΓΗ',
    [`${PRODUCTS_NS}.variety_name`]: 'Όνομα',
    [`${PRODUCTS_NS}.variety_price`]: 'Τιμή',
    [`${PRODUCTS_NS}.delete_product`]: 'Διαγραφή προϊόντος',
    [`${PRODUCTS_NS}.delete_product_confirm`]:
        'Είστε σίγουροι ότι θέλετε να διαγράψετε το προϊόν "{{id}} - {{name}}"; Η ενέργεια αυτή είναι μη αντιστρέψιμη!',
    [`${STORE_CONFIG_NS}.languages_validation`]:
        'Πρέπει να επιλεγχθεί τουλάχιστον μία γλώσσα',
    [`${STORE_CONFIG_NS}.default_lang_ui_validation`]:
        'Αυτή η γλώσσα δεν είναι επιλεγμένη στη λίστα επιθυμητών γλωσσών',
    [`${STORE_CONFIG_NS}.card_payment`]: 'ΠΛΗΡΩΜΗ ΜΕ ΚΑΡΤΑ',
    [`${STORE_CONFIG_NS}.pos_devices`]: 'ΑΡΙΘΜΟΣ ΣΥΣΚΕΥΩΝ POS',
    [`${STORE_CONFIG_NS}.pos_movable`]: 'ΜΕΤΑΦΕΡΟΜΕΝΗ ΣΥΣΚΕΥΗ POS',
    [`${STORE_CONFIG_NS}.free_wifi`]: 'ΠΑΡΟΧΗ ΔΩΡΕΑΝ WIFI',
    [`${STORE_CONFIG_NS}.customer_ordering`]: 'ΔΥΝΑΤΟΤΗΤΑ ΠΑΡΑΓΓΕΛΙΩΝ ΑΠΟ ΠΕΛΑΤΗ',
    [`${STORE_CONFIG_NS}.geolocation`]: 'ΑΣΦΑΛΕΙΑ ΜΕ GEOLOCATION',
    [`${STORE_CONFIG_NS}.authentication`]: '2 FACTOR AUTHENTICATION',
    [`${STORE_CONFIG_NS}.logo`]: 'ΔΙΑΘΕΣΙΜΟ ΛΟΓΟΤΥΠΟ',
    [`${STORE_CONFIG_NS}.languages`]: 'ΕΠΙΘΥΜΗΤΕΣ ΓΛΩΣΣΕΣ',
    [`${STORE_CONFIG_NS}.ui_lang`]: 'ΚΥΡΙΑ ΓΛΩΣΣΑ UI',
    [`${STORE_CONFIG_NS}.menu_lang`]: 'ΚΥΡΙΑ ΓΛΩΣΣΑ ΜΕΝΟΥ',
    [`${STORE_CONFIG_NS}.people_table`]: 'ΑΡΙΘΜΟΣ ΑΤΟΜΩΝ ΑΝΑ ΤΡΑΠΕΖΙ',
    [`${STORE_CONFIG_NS}.missing_logo`]: 'Πρέπει να επιλέξετε ένα λόγότυπο πρώτα',
    [`${STORE_CONFIG_NS}.upload_logo_error`]:
        'Παρουσιάστηκε σφάλμα κατά την αποθήκευση του λογοτύπου',
    [`${TABLES_NS}.table_code_validation`]: 'Επιτρέπονται μέχρι 5 χαρακτήρες',
    [`${TABLES_NS}.print_dimensions`]: 'ΔΙΑΣΤΑΣΕΙΣ ΕΚΤΥΠΩΣΗΣ',
    [`${TABLES_NS}.print_title`]: 'ΔΗΜΙΟΥΡΓΙΑ PDF ΚΑΡΤΕΛΑΣ ΤΡΑΠΕΖΙΟΥ',
    [`${TABLES_NS}.print_languages`]: 'ΓΛΩΣΣΕΣ ΕΚΤΥΠΩΣΗΣ',
    [`${TABLES_NS}.pdf_file`]: 'ΕΠΙΛΟΓΗ ΤΡΑΠΕΖΙΟΥ',
    [`${TABLES_NS}.pdf_current_table`]: 'ΕΝΑ ΤΡΑΠΕΖΙ (ΠΑΡΟΝ)',
    [`${TABLES_NS}.pdf_all_tables`]: 'ΟΛΑ ΤΑ ΤΡΑΠΕΖΙΑ',
    [`${TABLES_NS}.pdf_create`]: 'ΔΗΜΙΟΥΡΓΙΑ PDF',
    [`${TABLES_NS}.pdf_create_info`]:
        'ΜΕΤΑ ΤΗΝ ΟΛΟΚΛΗΡΩΣΗ ΑΠΟΣΤΕΛΛΕΤΑΙ ΑΡΧΕΙΟ .ZIP ΣΤΟ E-MAIL ΠΟΥ ΕΧΕΙ ΔΗΛΩΘΕΙ ΑΠΟ ΤΟ ΧΡΗΣΤΗ',
    [`${TABLES_NS}.table_code`]: 'ΚΩΔΙΚΟΣ',
    [`${TABLES_NS}.table_description`]: 'ΠΕΡΙΓΡΑΦΗ',
    [`${TABLES_NS}.table_seats`]: 'ΘΕΣΕΙΣ',
    [`${TABLES_NS}.table_added`]: 'Το τραπέζι "{{code}}" προστέθηκε επιτυχώς',
    [`${TABLES_NS}.table_updated`]: 'Το τραπέζι "{{code}}" αποθηκεύτηκε επιτυχώς',
    [`${TABLES_NS}.max_lang_selection`]:
        'Μπορείτε να επιλέξετε μέχρι 2 γλώσσες για τη διάσταση εκτύπωσης A7 light',
    [`${TABLES_NS}.lang_selection_validation`]:
        'Μπορείτε να επιλέξετε μόνο 1 γλώσσα για την επιλεγμένη διάσταση εκτύπωσης',
    [`${STORE_CLOSING_NS}.message.label`]: 'MHNYMA',
    [`${STORE_CLOSING_NS}.message.displayFrom`]: 'ΕΜΦΑΝΙΣΗ MHNYMAΤΟΣ ΑΠΟ',
    [`${STORE_CLOSING_NS}.description.label`]: 'ΠΕΡΙΓΡΑΦΗ',
    [`${STORE_CLOSING_NS}.from`]: 'AΠΟ',
    [`${STORE_CLOSING_NS}.to`]: 'ΜΕΧΡΙ',
    [`${STORE_CLOSING_NS}.form.invalid_display_date`]:
        'Η ημερομηνία εμφάνισης δεν μπορεί να είναι μετά την ημερομηνία κλεισίματος',
    [`${STORE_CLOSING_NS}.form.invalid_range`]:
        'Η ημερομηνία έναρξης κλεισίματος δεν μπορεί να είναι μετά το τέλος κλεισίματος',
    [`${STORE_CLOSING_NS}.delete_closure`]: 'Διαγραφή καταχώρισης κλεισίματος',
    [`${STORE_CLOSING_NS}.delete_closure_confirm`]:
        'Είστε σίγουροι ότι θέλετε να διαγράψετε την καταχώρισης κλεισίματος "{{id}} - {{shortDescription}}"; Η ενέργεια αυτή είναι μη αντιστρέψιμη!',
    [`${PRODUCT_CATEGORIES}`]: 'ΚΑΤΗΓΟΡΙΕΣ ΠΡΟΪΟΝΤΩΝ',
    [`${PRODUCTS}`]: 'ΠΡΟΪΟΝΤΑ',
    [`${EMPLOYEES}`]: 'ΥΠΑΛΛΗΛΟΙ ΚΑΤΑΣΤΗΜΑΤΟΣ',
    [`${TABLES}`]: 'ΤΡΑΠΕΖΙΑ ΚΑΤΑΣΤΗΜΑΤΟΣ',
    [`${CONFIGURATION}`]: 'ΡΥΘΜΙΣΕΙΣ ΚΑΤΑΣΤΗΜΑΤΟΣ',
    [`${ACCOUNT}`]: 'ΡΥΘΜΙΣΕΙΣ ΛΟΓΑΡΙΑΣΜΟΥ',
    [`${STORE_CLOSING}`]: 'ΚΛΕΙΣΙΜΟ ΚΑΤΑΣΤΗΜΑΤΟΣ',
    [ImageType.BEER]: 'Μπύρες',
    [ImageType.BEVERAGE]: 'Αναψυκτικά',
    [ImageType.BREAKFAST]: 'Πρωινό',
    [ImageType.BURGER]: 'Burgers',
    [ImageType.COCTAIL]: 'Κοκτέιλς',
    [ImageType.COFFEE]: 'Καφές',
    [ImageType.FOOD]: 'Φαγητό',
    [ImageType.ICE_CREAM]: 'Παγωτά',
    [ImageType.SWEETS]: 'Γλυκά',
    [ImageType.WINE]: 'Κρασιά',
    [ImageType.FISH]: 'Ψάρι',
    [ImageType.MEAT]: 'Κρέας',
    [ImageType.PIZZA]: 'Πίτσα',
    [`${EMPLOYEES_NS}.invalid_email`]: 'Η διεύθυνση email δεν είναι έγκυρη',
    [`${STORE_CLOSING_NS}.success`]:
        'Οι ώρες κλεισίματος του καταστήματος ανανεώθηκαν επιτυχώς'
};

export default GR_TRANSLATION;
